import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=be1eb918&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"
import style0 from "./product-list.vue?vue&type=style&index=0&id=be1eb918&prod&scoped=true&lang=css"
import style1 from "./product-list.vue?vue&type=style&index=1&id=be1eb918&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1eb918",
  null
  
)

export default component.exports